import { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { runRateAnnual } from '../../pages/CaCornerPage';

const eur = (v) => (v ? `${Math.round(v).toLocaleString('fr-FR')} €` : 'NC');
const evo = (a, b) => (a && b ? ((a - b) / b) * 100 : null);
const Evo = ({ v }) => (v == null ? null : (
  <span className={`ml-1 text-[11px] font-bold ${v >= 0 ? 'text-emerald-300' : 'text-rose-300'}`}>{v >= 0 ? '+' : ''}{v.toFixed(1)} %</span>
));

// Client WASABI existant (renouvellement) : rappel des données CA Corner, rapprochées par enseigne + ville.
export const RenewalCornerBox = ({ generalInfo }) => {
  const { api } = useAuth();
  const [c, setC] = useState(null);
  const enseigne = generalInfo?.retailer_name;
  const city = generalInfo?.city;
  useEffect(() => {
    if (!enseigne || !city) return;
    api().get('/ca-corner/match', { params: { enseigne, city } }).then(({ data }) => setC(data?.corner || null)).catch(() => setC(null));
  }, [api, enseigne, city]);
  if (!c) return null;
  const rr = runRateAnnual(c);
  const n1Ht = c.ca_n1 ? c.ca_n1 / 1.1 : null;
  const items = [
    ['Run-rate prévisionnel HT', <>{eur(rr)}<Evo v={evo(rr, n1Ht)} /></>, 'rr'],
    ['CA N-1 TTC', <>{eur(c.ca_n1)}<Evo v={evo(c.ca_n1, c.ca_n2)} /></>, 'n1'],
    ['CA N-2 TTC', eur(c.ca_n2), 'n2'],
    ['Commission', c.taux_commission != null ? `${c.taux_commission} %` : 'NC', 'comm'],
    ['Fin de contrat', c.date_fdc || 'NC', 'fdc'],
  ];
  return (
    <div className="mx-4 flex-1 max-w-3xl rounded-xl bg-slate-950 px-4 py-2.5 text-white ring-2 ring-fuchsia-400 shadow-[0_0_18px_rgba(232,121,249,0.65)]" data-testid="renewal-corner-box">
      <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-fuchsia-300">
        <Zap className="w-3.5 h-3.5" />Historique DATA connu du client · Client WASABI · {c.name_sf || c.name_powerbi}
      </p>
      <div className="mt-1.5 grid grid-cols-5 gap-3">
        {items.map(([label, value, k]) => (
          <div key={k} data-testid={`renewal-corner-${k}`}>
            <p className="text-[10px] text-slate-400 leading-tight">{label}</p>
            <p className="text-sm font-bold tabular-nums whitespace-nowrap">{value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
